import { render } from "./SelectMeetingAttendees.vue?vue&type=template&id=242b2fda&ts=true"
import script from "./SelectMeetingAttendees.vue?vue&type=script&lang=ts"
export * from "./SelectMeetingAttendees.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__